import React, { useContext, useState } from "react";
import CartContext from "../../../context/CartContext";
import CartItem from "./CartItem";
import Modal from "../../Modal/Modal";
import { Link } from "react-router-dom";
const CartPopup = () => {
  // className={this.props.globalState.popupCartOpen" =="true" ? 'active' : ''}
  const {
    showCart,
    cartItems,
    showHideCart,
    removeItem,
    total,
    itemCount,
    subTotal,
  } = useContext(CartContext);
  console.log("CLG CartItems", cartItems);

  const [modalState,setmodalState] = useState(false);
  function popupModal() {
    setmodalState(!modalState)
  }

  const [modalOpen, setModalOpen] = useState(false);
  const openModal = () => {
    setShowModal((prev) => !prev);
  };
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <section id="cart-popup" className={showCart === true ? "active" : ""}>
        <div className="cart-title">
          <div className="title">My Cart</div>
        </div>
        <div className="cart-items">
          <div className="item-container">
            {cartItems.map((item, index) => (
              <div className="item" key={index}>
                <img src={item.image_url} />
                <div className="delete-btn">
                  <div className="circle" onClick={() => removeItem(item)}>
                    X
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="product-total">
          <div className="inside-container">
            <div className="title">Total</div>
            <div className="number">
              {" "}
              x{cartItems.length ? <span>{cartItems.length}</span> : ""}
            </div>
          </div>
        </div>
        <div className="price-total">
          <div className="inside-container">
            <div className="title">Total</div>
            <div className="number"> ${total}</div>
          </div>
        </div>
        <div className="checkout">
          <div className="title modal-trigger" onClick={openModal}>
            <span className="toggle-modal ti-shopping-cart" onClick={popupModal}></span>
            <Modal toggle={modalState} action={popupModal} ></Modal>
            {/* <Link to="/checkout">Checkout</Link> */}
          </div>
          {/* <span className="ti-shopping-cart"></span> */}
        </div>
        {/* {modalOpen && <Modal setOpenModal={setModalOpen} />} */}
      </section>
    </>
  );
};

export default CartPopup;
